<template>
  <div class="app-page box-card">
    <div class="box-card-content">
      <div class="reset-query query">
        <el-form :inline="true" :model="queryForm" class="reset-form-inline">
          <el-form-item label="时间">
            <template slot="label">
              <I18Lang id="fundstreams3" defaultText="时间" />
            </template>
            <el-date-picker
              v-model="queryDate"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="-"
              :start-placeholder="$t('public22')"
              :end-placeholder="$t('public23')"
              @change="dateChange"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="来源">
            <template slot="label">
              <I18Lang id="fundstreams8" defaultText="来源" />
            </template>
            <el-select v-model="queryForm.source" :placeholder="$t('public17')">
              <el-option :label="$t('public18')" value=""></el-option>
              <el-option
                v-for="(item, key) in sourceOptions"
                :key="key"
                :label="item"
                :value="key"
              ></el-option>
            </el-select>
          </el-form-item>

          <div class="btn kg-btn2" @click="queryQuery">
            <I18Lang id="my85" defaultText="查询" />
          </div>
          <div class="btn kg-refresh btn-query-refresh" @click="resetQuery"></div>
        </el-form>
      </div>

      <div class="reset-table table">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column width="200" prop="stream_no" label="流水号">
            <template slot="header">
              {{ ledgerLabels.reference }}
            </template>
          </el-table-column>

          <el-table-column label="时间">
            <template slot="header">
              <I18Lang id="fundstreams3" defaultText="时间" />
            </template>
            <template slot-scope="scope">
              {{ scope.row.create_time_formatted || scope.row.create_time || '-' }}
            </template>
          </el-table-column>

          <el-table-column prop="amount" label="金额(MEQ)">
            <template slot="header">
              {{ ledgerLabels.amount }}
            </template>
          </el-table-column>

          <el-table-column prop="after_balance" label="操作后余额(MEQ)">
            <template slot="header">
              {{ ledgerLabels.balance }}
            </template>
          </el-table-column>

          <el-table-column label="操作来源">
            <template slot="header">
              <I18Lang id="fundstreams6" defaultText="操作来源" />
            </template>
            <template slot-scope="scope">
              {{ getDisplaySourceText(scope.row) }}
            </template>
          </el-table-column>

          <el-table-column label="款项说明">
            <template slot="header">
              <I18Lang id="fundstreams7" defaultText="款项说明" />
            </template>
            <template slot-scope="scope">
              {{ getDisplayRemarkText(scope.row) }}
            </template>
          </el-table-column>
        </el-table>

        <div class="page">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            @current-change="pageChange"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'fundStreams',
  data () {
    return {
      queryDate: '',
      queryForm: {
        page: 1,
        size: 10,
        start_time: '',
        end_time: '',
        source: ''
      },
      tableData: [],
      total: 0,
      sourceOptions: {
        1: this.$t('fundstreams9'),
        2: this.$t('fundstreams10'),
        3: this.$t('fundstreams11'),
        4: this.$t('fundstreams12'),
        5: this.$t('fundstreams13')
      }
    }
  },
  created () {
    this.getList()
  },
  computed: {
    ledgerLabels () {
      const locale = this.getLocaleKey()
      return {
        reference: { zh: '流水号', en: 'Reference No.', ja: '流水番号' }[locale],
        amount: { zh: '金额(MEQ)', en: 'Amount (MEQ)', ja: '金額 (MEQ)' }[locale],
        balance: { zh: '操作后余额(MEQ)', en: 'Balance After (MEQ)', ja: '変更後残高 (MEQ)' }[locale]
      }
    }
  },
  methods: {
    queryQuery () {
      this.pageChange(1)
    },
    resetQuery () {
      this.queryForm.start_time = ''
      this.queryForm.end_time = ''
      this.queryForm.source = ''
      this.queryDate = ''
      this.pageChange(1)
    },
    dateChange (val) {
      this.queryForm.start_time = val ? val[0] : ''
      this.queryForm.end_time = val ? val[1] : ''
    },
    pageChange (page) {
      this.queryForm.page = page
      this.getList()
    },
    getLocaleKey () {
      const locale = this.$i18n && this.$i18n.locale ? this.$i18n.locale : 'zh'
      if (locale.indexOf('en') === 0) return 'en'
      if (locale.indexOf('ja') === 0) return 'ja'
      return 'zh'
    },
    getDisplaySourceText (row) {
      const locale = this.getLocaleKey()
      const code = String((row && row.source_code) || '').trim()
      const byCode = {
        wallet: { zh: '钱包', en: 'Wallet', ja: 'ウォレット' },
        cash: { zh: '现金账户', en: 'Cash Account', ja: '現金口座' },
        trading_account: { zh: '交易账户', en: 'Trading Account', ja: '取引口座' },
        daily_growth_bonus: { zh: '每日成长赠金', en: 'Daily Growth Bonus', ja: 'デイリー成長ボーナス' },
        risk_compensation_bonus: { zh: '风险补偿赠金', en: 'Risk Compensation Bonus', ja: 'リスク補償ボーナス' }
      }
      if (byCode[code]) return byCode[code][locale]
      const text = String((row && row.source_text) || '').trim()
      const map = {
        现金: { zh: '现金账户', en: 'Cash Account', ja: '現金口座' },
        现金账户: { zh: '现金账户', en: 'Cash Account', ja: '現金口座' },
        钱包: { zh: '钱包', en: 'Wallet', ja: 'ウォレット' },
        交易账户: { zh: '交易账户', en: 'Trading Account', ja: '取引口座' },
        抵扣奖励: { zh: '风险补偿赠金', en: 'Risk Compensation Bonus', ja: 'リスク補償ボーナス' },
        风险补偿赠金: { zh: '风险补偿赠金', en: 'Risk Compensation Bonus', ja: 'リスク補償ボーナス' },
        挖矿奖励: { zh: '每日成长赠金', en: 'Daily Growth Bonus', ja: 'デイリー成長ボーナス' },
        每日成长赠金: { zh: '每日成长赠金', en: 'Daily Growth Bonus', ja: 'デイリー成長ボーナス' }
      }
      return map[text] ? map[text][locale] : (text || '-')
    },
    getDisplayRemarkText (row) {
      const locale = this.getLocaleKey()
      const code = String((row && row.remark_code) || '').trim()
      const byCode = {
        deposit: { zh: '入金到账', en: 'Deposit Credited', ja: '入金反映' },
        withdraw_usdt: { zh: 'USDT出金', en: 'USDT Withdrawal', ja: 'USDT出金' },
        withdraw_bank: { zh: '银行卡出金', en: 'Bank Withdrawal', ja: '銀行口座へ出金' },
        withdraw_rejected_refund: { zh: '出金审核失败退回', en: 'Withdrawal Rejected - Funds Returned', ja: '出金否認・資金返却' },
        cash_to_trading: { zh: '转入交易账户', en: 'Transfer to Trading Account', ja: '取引口座へ振替' },
        trading_to_cash: { zh: '转入现金账户', en: 'Transfer to Cash Account', ja: '現金口座へ振替' },
        user_transfer: { zh: '用户转账', en: 'User Transfer', ja: 'ユーザー間振替' },
        wallet_to_cash: { zh: '钱包转入现金账户', en: 'Wallet to Cash Account', ja: 'ウォレットから現金口座へ振替' },
        premium_membership_purchase: { zh: '购买高级会员', en: 'Premium Membership Purchase', ja: 'プレミアム会員購入' },
        risk_bonus_loss_offset: { zh: '风险赠金抵扣亏损', en: 'Risk Bonus Loss Offset', ja: 'リスクボーナス損失充当' },
        daily_growth_bonus_reward: { zh: '每日成长赠金发放', en: 'Daily Growth Bonus Credit', ja: 'デイリー成長ボーナス付与' },
        daily_growth_bonus_activation: { zh: '每日成长赠金激活', en: 'Daily Growth Bonus Activation', ja: 'デイリー成長ボーナス有効化' }
      }
      if (byCode[code]) return byCode[code][locale]
      const text = String((row && (row.type_text || row.remark)) || '').trim()
      return text || '-'
    },
    getList () {
      this.$http.post('/api/cash/fundStreams', this.queryForm).then((result) => {
        this.tableData = (result && result.list) || []
        this.total = Number((result && result.total) || 0)
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
